import { TaxCategoryState } from "@/vuex/modules/taxCategory/taxCategory.types";

export const state: TaxCategoryState = {
  taxCategories: [],
  taxCategory: null,
  loading: false,
  pagination: null
};
